import create from 'zustand'
import { IolLibrary } from '../../types/graphql'

type IolFormValues = {
  data: IolLibrary
  isEditing: boolean
}

type IolFormActions = {
  setData: (data: IolLibrary) => void
  reset: () => void
  setIsEditing: (isEditing: boolean) => void
}

export type IolFormState = IolFormValues & IolFormActions

const initialState: IolFormValues = {
  isEditing: false,
  data: {
    internalAnnotations: '',
    position: 0,
    name: '',
    slug: '',
    enable: true,
    price: {
      float: 0
    },
    properties: {
      graphics: [],
      items: [],
      satisfaction: []
    },
    cacheKey: '',
    thumb: '',
    timestamp: {}
  }
}

export const useIolForm = create<IolFormState>(set => ({
  ...initialState,
  setData: data => set(state => ({ ...state, data })),
  reset: () => set({ ...initialState }),
  setIsEditing: isEditing => set(state => ({ ...state, isEditing }))
}))
